import * as v from "valibot";

// Base Contact Fields Schema in snake_case for the webhook schema
export const baseContactFieldsSnakeCase = {
  contact_id: v.string(),
  first_name: v.string(),
  last_name: v.string(),
  full_name: v.optional(v.string()),
  email: v.pipe(v.string(), v.email()),
  phone: v.optional(v.string()),
  tags: v.optional(v.string()),
  address1: v.optional(v.string()),
  city: v.optional(v.string()),
  state: v.optional(v.string()),
  country: v.optional(v.string()),
  timezone: v.nullish(v.string()),
  date_created: v.optional(v.string()),
  postal_code: v.optional(v.string()),
  company_name: v.optional(v.string()),
  website: v.optional(v.string()),
  date_of_birth: v.optional(v.string()),
  contact_source: v.optional(v.string()),
  full_address: v.optional(v.string()),
  contact_type: v.optional(v.string()),
  gclid: v.optional(v.nullable(v.string())),
};

// Base Contact Fields Schema in camelCase for the contact schemas
export const baseContactFieldsCamelCase = {
  contactId: v.optional(v.string()),
  firstName: v.optional(v.nullable(v.string())),
  lastName: v.optional(v.nullable(v.string())),
  name: v.optional(v.nullable(v.string())),
  fullName: v.optional(v.string()),
  email: v.optional(v.nullable(v.pipe(v.string(), v.email()))),
  phone: v.optional(v.nullable(v.string())),
  tags: v.optional(v.array(v.string())),
  address1: v.optional(v.nullable(v.string())),
  city: v.optional(v.nullable(v.string())),
  state: v.optional(v.nullable(v.string())),
  country: v.optional(v.string()),
  timezone: v.nullish(v.string()),
  dateCreated: v.optional(v.string()),
  postalCode: v.optional(v.string()),
  companyName: v.optional(v.string()),
  website: v.optional(v.nullable(v.pipe(v.string(), v.url()))),
  dateOfBirth: v.optional(v.string()),
  contactSource: v.optional(v.nullable(v.string())),
  fullAddress: v.optional(v.string()),
  contactType: v.optional(v.string()),
  gclid: v.optional(v.nullable(v.string())),
};
